<template>
  <div class="payCard">
    <div>
      <div class="list-header" v-if="mode === 'composition'">
        <div>期数</div>
        <div>总还款金额</div>
        <div>商贷还款</div>
        <div>公积金还款</div>
      </div>
      <div class="list-header" v-else>
        <div>期数</div>
        <div>月供总额</div>
        <div>月供本金</div>
        <div>月供利息</div>
        <div>剩余贷款</div>
      </div>
    </div>
    <div class="list-body" v-if="mode === 'composition'">
      <div class="per-month" v-for="(item, index) in dataList" :key="index">
        <div>{{ item.name }}</div>
        <div>{{ item.mPay }}</div>
        <div>{{ item.mComPay }}</div>
        <div>{{ item.mFundPay }}</div>
      </div>
    </div>
    <div class="list-body" v-else>
      <div class="per-month" v-for="(item, index) in dataList" :key="index">
        <span>{{ item.name }}</span>
        <span>{{ item.mPay }}</span>
        <span>{{ item.mPrincipal }}</span>
        <span>{{ item.mPayInter }}</span>
        <span>{{ item.mLeft }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PayList",
  props: {
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dataList: [],
      mode: "",
    };
  },
  created() {
    const type = this.type;
    this.mode = this.$route.query.type;
    this.dataList = this.$store.state.calcuRes[type].group_detail;
  },
};
</script>
<style scoped>
.payCard {
  background-color: #f8f8f8;
  margin-left: 18px;
  margin-right: 18px;
}
.list-header {
  width: auto;
  height: 88px;
  background-color: #f8f8f8;
  display: flex;
  padding: 24px 32px;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  font-size: 28px;
  color: #222222;
  line-height: 40px;
}
.per-month {
  height: 88px;
  display: flex;
  padding: 24px 32px;
  justify-content: space-between;
  align-items: center;
  font-weight: 400;
  font-size: 24px;
  color: #222222;
  line-height: 34px;
}
.list-body .per-month:nth-child(odd) {
  background-color: #fff; /* 设置为需要的背景色 */
}
</style>
